export default function Logo({ variant = "bull", size = 32, className = "", showWordmark = true }) {
    if (variant === "wordmark-white") {
        return (
            <img
                src="/bc-wordmark-white.png"
                alt="Brothers Coffee Roastery"
                style={{ height: size }}
                className={className}
                data-testid="brand-wordmark-white"
            />
        );
    }
    return (
        <div className={`flex items-center gap-2 ${className}`}>
            <img
                src="/bc-bull.png"
                alt="Brothers Coffee Roastery"
                style={{ height: size, width: "auto" }}
                data-testid="brand-bull"
            />
            {showWordmark && (
                <div className="leading-tight">
                    <div className="font-display font-bold text-espresso text-[15px] tracking-tight">Brothers Coffee</div>
                    <div className="text-[10px] uppercase tracking-[0.2em] text-[#7A726D]">Roastery</div>
                </div>
            )}
        </div>
    );
}
